import type { FluxErrorEntityErrorCodes } from '../types.js';

export const DeadlineErrorCodes = {
  DeadlineNotFound: {
    code: 'deadline/not-found',
    explanation: 'O prazo que você está tentando acessar não foi encontrado.',
    localizations: {},
    message: 'O prazo especificado não foi encontrado.',
  },
} as const satisfies FluxErrorEntityErrorCodes<'deadline'>;
